import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';

class TransformationService extends Api {
  transformDocument = async (
    sku: string,
    selection: Record<string, string>,
    version: number,
    docUrl: string,
  ) => {
    try {
      // this service transfers the scene based on the selection. for example, embroidery is shown as embroidery
      const { data } = await this.httpClient.get('/v1/pipelines/designTransfers:processDocUrl', {
        params: {
          docUrl,
          sku,
          skuVariables: JSON.stringify(selection),
          version,
        },
      });
      return data;
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        extra: {
          docUrl,
          sku,
          skuVariables: JSON.stringify(selection),
          version,
        },
        tags: {
          component: 'gallery',
          fileLocation: 'TransformationService.ts',
          featureFunction: 'transformDocument',
        },
        fingerprint: ['transform-document'],
      });
      throw error;
    }
  };

  buildSkuVariables = (
    selection: Record<string, string>,
    decoEnabledOptions: Record<string, string> = {},
    requiredDecoOptions: Record<string, string> = {},
  ): Record<string, string> => ({
    ...selection,
    ...decoEnabledOptions,
    ...requiredDecoOptions,
  });
}

export default TransformationService;
